import { getTablePermissions } from "@/lib/permissions";
import type { UserRoleType } from "@/types/auth";

export const getCourseTableConfig = (userRoles: UserRoleType[] | null, displayNames?) => {
  const permissions = getTablePermissions(userRoles, "courses");

  return {
    entityName: "Course",
    entityNamePlural: "Courses",

    tableConfig: {
      ignore: ["tenant_id", "created_by", "meta_data"],
      readonly: ["id", "created_at"],
      validators: {},
      headerFunc: (name: string) => {
        switch (name) {
          case "id":
            return `${displayNames?.courses?.name ?? "Course"} Id`;
          default:
            return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        }
      },
      cellTextCallback: (value: any, key: string) => {
        if (value == null) return "";
        if (key === "id") return value.toString().slice(0, 6).toUpperCase();
        if (key === "created_at") return value; // let datetimeprovider handle formatting
        return typeof value === "string" ? value : JSON.stringify(value);
      },
      dataTypes: {
        created_at: "date" as const,
        status: {
          type: "enum" as const,
          options: [
            { value: "DRAFT", color: "todo" },
            { value: "ACTIVE", color: "complete" },
          ],
        },
        open_enrollment: "boolean" as const,
        archived: "boolean" as const,
      },
    },

    filterChoices: [
      {
        name: "id",
        kind: "text" as const,
        displayName: `${displayNames?.courses?.name ?? "Course"} Id`,
        menus: ["filter", "visible"] as const,
      },
      { name: "name", kind: "text", menus: ["filter", "visible"] as const },
      { name: "status", kind: "text", menus: ["filter", "visible"] as const },
      { name: "description", kind: "text", menus: ["filter", "visible"] as const },
      { name: "open_enrollment", kind: "boolean", menus: ["filter", "visible"] as const },
      { name: "archived", kind: "boolean", menus: ["filter", "visible"] as const },
      { name: "created_at", kind: "date", menus: ["filter", "visible", "orderby"] as const },
    ],
    ...permissions,
    storageKey: "course_flyout",
  };
};
